import { useEffect } from "react";

/**
 * Swap the SPA's default <link rel="manifest"> with a page-specific one so
 * Chrome/Edge treat the Big Screen and the Countdown as two distinct
 * installable PWAs (different manifest id => different taskbar icon).
 *
 * On unmount, we restore whatever manifest was there before.
 */
export default function usePwaManifest(href) {
  useEffect(() => {
    if (!href) return undefined;
    const link = document.querySelector('link[rel="manifest"]');
    if (!link) return undefined;
    const previous = link.getAttribute("href");
    if (previous !== href) {
      link.setAttribute("href", href);
    }
    return () => {
      if (link.isConnected && previous && previous !== href) {
        link.setAttribute("href", previous);
      }
    };
  }, [href]);
}
